import React from 'react';
import API from '../api';

import Financials from '../Financials/Financials'
import FinancialsFilters from './FinancialsFilters'

export type Props = {
  starting: string
  ending: string
}
export default function FinancialsSection({ starting, ending }: Props) {
  const [financialsData, setFinancialsData] = React.useState()
  const [isMissingRange, setIsMissingRange] = React.useState(false)
  const [hasError, setHasError] = React.useState(false)

  async function getFinancialsData({ divisionIds, salesPersonEmails, crewForemanEmails }: { divisionIds?: string[], salesPersonEmails?: string[], crewForemanEmails?: string[] } = {}) {
    if (!starting || !ending) {
      setIsMissingRange(true)
      return
    }

    setIsMissingRange(false)
    setHasError(false)
    try {
      const response = await API.post("graphing/financials-data", { start: starting, end: ending, divisionIds, salesPersonEmails, crewForemanEmails });
      setFinancialsData(response.data);
    } catch (error) {
      // Error handling - the error will be caught and logged by global error handlers
      console.error("Failed to fetch financials data:", error);
      setHasError(true)
    }
  }

  function renderFilters() {
    return <FinancialsFilters onChange={getFinancialsData}></FinancialsFilters>
  }

  React.useEffect(() => {
    getFinancialsData()
    /* eslint-disable-next-line */
  }, [starting, ending]);

  return (
    <div className="financials-section">
      {isMissingRange && <div className="financials">
        <div className="title">
          <h1>Company-wide Job Costing</h1>
          <p>Please select a time range at the top of the page.</p>
        </div>
      </div>}
      {hasError && <div className="financials">
        <div className="title">
          <h1>Company-wide Job Costing</h1>
          <p>Error loading data</p>
        </div>
      </div>}
      {!isMissingRange && !hasError && <Financials title="Company-wide Job Costing" data={financialsData} renderFilters={renderFilters} displayLaborHours={true} displayJobs />}
    </div>
  );
}
